/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractorAddressesRequestPlaceId } from '../models/ContractorAddressesRequestPlaceId';
import type { ContractorAddressesRequestPOBox } from '../models/ContractorAddressesRequestPOBox';
import type { ContractorAddressResponse } from '../models/ContractorAddressResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContractorAddressRoutesRepository {
  /**
   * Get
   * List contractor address by id.
   * @returns ContractorAddressResponse Successful Response
   * @throws ApiError
   */
  public static contractorAddressRoutesGet({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<ContractorAddressResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/contractor/address/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update
   * Update a contractor address by id.
   * @returns ContractorAddressResponse Successful Response
   * @throws ApiError
   */
  public static contractorAddressRoutesUpdate({
    id,
    requestBody,
    authorization,
  }: {
    id: string,
    requestBody: (ContractorAddressesRequestPOBox | ContractorAddressesRequestPlaceId),
    authorization?: string,
  }): CancelablePromise<ContractorAddressResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/contractor/address/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete
   * Delete a contractor address by id.
   * @returns void
   * @throws ApiError
   */
  public static contractorAddressRoutesDelete({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/contractor/address/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create
   * Adds a new contractor address.
   * @returns ContractorAddressResponse Successful Response
   * @throws ApiError
   */
  public static contractorAddressRoutesCreate({
    contractorId,
    requestBody,
    authorization,
  }: {
    contractorId: string,
    requestBody: (ContractorAddressesRequestPOBox | ContractorAddressesRequestPlaceId),
    authorization?: string,
  }): CancelablePromise<ContractorAddressResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/contractor/{contractor_id}/address',
      path: {
        'contractor_id': contractorId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
